import { manufacturingFetch } from "@/lib/manufacturingClient";
import type {
  MfgBomAuditKind,
  MfgBomAuditNodeResult,
  MfgBomAuditNodeSaveResponse,
  MfgBomAuditSessionAbandonResponse,
  MfgBomAuditSessionDetailResponse,
  MfgBomAuditSessionOpenResponse,
  MfgBomAuditSessionStatus,
  MfgBomAuditSessionsListResponse,
  MfgBomAuditStartSubAuditResponse,
} from "@/lib/manufacturing/types/bomAudit";

export function listManufacturingBomAuditSessions(opts?: {
  status?: MfgBomAuditSessionStatus[] | string;
  recipe_id?: string;
  roots_only?: boolean;
}) {
  const params = new URLSearchParams();
  if (opts?.status) {
    params.set(
      "status",
      Array.isArray(opts.status) ? opts.status.join(",") : opts.status
    );
  }
  if (opts?.recipe_id) params.set("recipe_id", opts.recipe_id);
  if (opts?.roots_only) params.set("roots_only", "1");
  const qs = params.toString();
  return manufacturingFetch<MfgBomAuditSessionsListResponse>(
    `/api/mfg/bom-audit/sessions${qs ? `?${qs}` : ""}`,
    { method: "GET" }
  );
}

export function getManufacturingBomAuditSession(session_id: string) {
  const params = new URLSearchParams({ session_id });
  return manufacturingFetch<MfgBomAuditSessionDetailResponse>(
    `/api/mfg/bom-audit/sessions/detail?${params.toString()}`,
    { method: "GET" }
  );
}

export function openManufacturingBomAuditSession(payload: {
  recipe_id: string;
  audit_kind: MfgBomAuditKind;
  plant_id?: string | null;
  notes?: string;
}) {
  return manufacturingFetch<MfgBomAuditSessionOpenResponse>(
    "/api/mfg/bom-audit/sessions/open",
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    }
  );
}

export function saveManufacturingBomAuditNode(payload: {
  node_id: string;
  result?: MfgBomAuditNodeResult;
  notes?: string;
  session_notes?: string;
  mark_session_partial?: boolean;
}) {
  return manufacturingFetch<MfgBomAuditNodeSaveResponse>("/api/mfg/bom-audit/nodes/save", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
}

export function startManufacturingBomAuditSubAudit(node_id: string) {
  return manufacturingFetch<MfgBomAuditStartSubAuditResponse>(
    "/api/mfg/bom-audit/start-sub-audit",
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ node_id }),
    }
  );
}

export function completeManufacturingBomAuditSession(payload: {
  session_id: string;
  notes?: string;
}) {
  return manufacturingFetch<MfgBomAuditSessionDetailResponse>(
    "/api/mfg/bom-audit/sessions/complete",
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    }
  );
}

export function abandonManufacturingBomAuditSession(payload: {
  session_id: string;
  as_partial?: boolean;
  notes?: string;
}) {
  return manufacturingFetch<MfgBomAuditSessionAbandonResponse>(
    "/api/mfg/bom-audit/sessions/abandon",
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    }
  );
}

export function reopenManufacturingBomAuditSession(session_id: string) {
  return manufacturingFetch<MfgBomAuditSessionDetailResponse>(
    "/api/mfg/bom-audit/sessions/reopen",
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ session_id }),
    }
  );
}
